var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showNotification)?_c('div',{staticClass:"notification",on:{"click":_vm.closeClicked}},[_c('div',{staticClass:"notification-grid content--max"},[_vm._v("\n      "+_vm._s(_vm.getCode())+"\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }